// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ConnectionStatusMessage, ConnectionStatusMessageT } from './connection-status-message';
import { EarthquakeProtectionMessage, EarthquakeProtectionMessageT } from './earthquake-protection-message';
import { EarthquakeStatusMessage, EarthquakeStatusMessageT } from './earthquake-status-message';
import { GeneralStatusMessage, GeneralStatusMessageT } from './general-status-message';
import { LoadWeigherStatusMessage, LoadWeigherStatusMessageT } from './load-weigher-status-message';
import { ModeStatusMessage, ModeStatusMessageT } from './mode-status-message';
import { TrafficStatusMessage, TrafficStatusMessageT } from './traffic-status-message';


export enum EscalatorStatusContent {
  NONE = 0,
  EarthquakeProtectionMessage = 1,
  EarthquakeStatusMessage = 2,
  GeneralStatusMessage = 3,
  ConnectionStatusMessage = 4,
  ModeStatusMessage = 5,
  TrafficStatusMessage = 6,
  LoadWeigherStatusMessage = 7
}

export function unionToEscalatorStatusContent(
  type: EscalatorStatusContent,
  accessor: (obj:ConnectionStatusMessage|EarthquakeProtectionMessage|EarthquakeStatusMessage|GeneralStatusMessage|LoadWeigherStatusMessage|ModeStatusMessage|TrafficStatusMessage) => ConnectionStatusMessage|EarthquakeProtectionMessage|EarthquakeStatusMessage|GeneralStatusMessage|LoadWeigherStatusMessage|ModeStatusMessage|TrafficStatusMessage|null
): ConnectionStatusMessage|EarthquakeProtectionMessage|EarthquakeStatusMessage|GeneralStatusMessage|LoadWeigherStatusMessage|ModeStatusMessage|TrafficStatusMessage|null {
  switch(EscalatorStatusContent[type]) {
    case 'NONE': return null; 
    case 'EarthquakeProtectionMessage': return accessor(new EarthquakeProtectionMessage())! as EarthquakeProtectionMessage;
    case 'EarthquakeStatusMessage': return accessor(new EarthquakeStatusMessage())! as EarthquakeStatusMessage;
    case 'GeneralStatusMessage': return accessor(new GeneralStatusMessage())! as GeneralStatusMessage;
    case 'ConnectionStatusMessage': return accessor(new ConnectionStatusMessage())! as ConnectionStatusMessage;
    case 'ModeStatusMessage': return accessor(new ModeStatusMessage())! as ModeStatusMessage;
    case 'TrafficStatusMessage': return accessor(new TrafficStatusMessage())! as TrafficStatusMessage;
    case 'LoadWeigherStatusMessage': return accessor(new LoadWeigherStatusMessage())! as LoadWeigherStatusMessage;
    default: return null;
  }
}

export function unionListToEscalatorStatusContent(
  type: EscalatorStatusContent, 
  accessor: (index: number, obj:ConnectionStatusMessage|EarthquakeProtectionMessage|EarthquakeStatusMessage|GeneralStatusMessage|LoadWeigherStatusMessage|ModeStatusMessage|TrafficStatusMessage) => ConnectionStatusMessage|EarthquakeProtectionMessage|EarthquakeStatusMessage|GeneralStatusMessage|LoadWeigherStatusMessage|ModeStatusMessage|TrafficStatusMessage|null, 
  index: number
): ConnectionStatusMessage|EarthquakeProtectionMessage|EarthquakeStatusMessage|GeneralStatusMessage|LoadWeigherStatusMessage|ModeStatusMessage|TrafficStatusMessage|null {
  switch(EscalatorStatusContent[type]) {
    case 'NONE': return null; 
    case 'EarthquakeProtectionMessage': return accessor(index, new EarthquakeProtectionMessage())! as EarthquakeProtectionMessage;
    case 'EarthquakeStatusMessage': return accessor(index, new EarthquakeStatusMessage())! as EarthquakeStatusMessage;
    case 'GeneralStatusMessage': return accessor(index, new GeneralStatusMessage())! as GeneralStatusMessage;
    case 'ConnectionStatusMessage': return accessor(index, new ConnectionStatusMessage())! as ConnectionStatusMessage;
    case 'ModeStatusMessage': return accessor(index, new ModeStatusMessage())! as ModeStatusMessage;
    case 'TrafficStatusMessage': return accessor(index, new TrafficStatusMessage())! as TrafficStatusMessage;
    case 'LoadWeigherStatusMessage': return accessor(index, new LoadWeigherStatusMessage())! as LoadWeigherStatusMessage;
    default: return null;
  }
}

export type EscalatorStatusContentT =
  | { type: 'NONE'; value: null }
  | { type: 'EarthquakeProtectionMessage'; value: EarthquakeProtectionMessageT }
  | { type: 'EarthquakeStatusMessage'; value: EarthquakeStatusMessageT }
  | { type: 'GeneralStatusMessage'; value: GeneralStatusMessageT }
  | { type: 'ConnectionStatusMessage'; value: ConnectionStatusMessageT }
  | { type: 'ModeStatusMessage'; value: ModeStatusMessageT }
  | { type: 'TrafficStatusMessage'; value: TrafficStatusMessageT }
  | { type: 'LoadWeigherStatusMessage'; value: LoadWeigherStatusMessageT };
